import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.audit');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";


@Component({
    selector: 'wiz-page-audit',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.audit/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.audit-page-size-control {
  display: inline-flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
  color: #64748b;
  font-size: 11px;
  font-weight: 600;
}

.audit-page-size-select-wrap {
  position: relative;
  display: inline-flex;
}

.audit-page-size-select {
  width: 76px;
  height: 36px;
  appearance: none;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #fff;
  padding: 0 28px 0 11px;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  outline: none !important;
  box-shadow: none !important;
  transition: border-color 150ms ease, background-color 150ms ease;
}

.audit-page-size-select:hover {
  border-color: #94a3b8;
  background: #f8fafc;
}

.audit-page-size-select:focus,
.audit-page-size-select:focus-visible {
  border: 2px solid #4f46e5;
  padding-right: 27px;
  padding-left: 10px;
  outline: none !important;
  box-shadow: none !important;
}

.audit-page-size-select-wrap > i {
  position: absolute;
  top: 50%;
  right: 10px;
  color: #94a3b8;
  font-size: 9px;
  pointer-events: none;
  transform: translateY(-50%);
}

@media (max-width: 639px) {
  .audit-page-size-control > span:first-child {
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    margin: -1px;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
  }
}`],
})
export class PageAuditComponent implements OnInit {
    public loading: boolean = true;
    public exporting: boolean = false;
    public rows: any[] = [];
    public total: number = 0;
    public page: number = 1;
    public dump: number = 20;
    public hasNext: boolean = false;
    public errorMessage: string = '';
    public filters: any = {
        event_type: '',
        target_type: '',
        status: '',
        actor_id: '',
        created_from: '',
        created_to: ''
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load();
    }

    private query() {
        return {
            ...this.filters,
            page: this.page,
            dump: this.dump
        };
    }

    public async load(resetPage: boolean = false) {
        if (resetPage) this.page = 1;
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('search', this.query());
            if (code !== 200) {
                this.errorMessage = data?.message || '감사 로그를 불러오지 못했습니다.';
                return;
            }
            this.rows = Array.isArray(data?.rows) ? data.rows : [];
            this.total = Number(data?.total || 0);
            this.page = Number(data?.page || this.page);
            this.dump = Number(data?.dump || this.dump);
            this.hasNext = data?.has_next === true;
        } catch (error) {
            this.errorMessage = '감사 로그를 불러오지 못했습니다.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async reset() {
        this.filters = {
            event_type: '',
            target_type: '',
            status: '',
            actor_id: '',
            created_from: '',
            created_to: ''
        };
        await this.load(true);
    }

    public async move(delta: number) {
        const next = this.page + delta;
        if (next < 1 || (delta > 0 && !this.hasNext)) return;
        this.page = next;
        await this.load();
    }

    public async download(format: 'csv' | 'json') {
        if (this.exporting) return;
        this.exporting = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('export', {
                ...this.filters,
                format,
                csrf_token: this.service.auth.session?.csrf_token || ''
            });
            if (code !== 200 || !data?.export) {
                await this.service.modal.error(data?.message || '감사 로그를 내보내지 못했습니다.');
                return;
            }
            const exported = data.export;
            let content = String(exported.content || '');
            if (format === 'csv' && content.charCodeAt(0) !== 0xfeff) content = '\ufeff' + content;
            const blob = new Blob([content], { type: exported.content_type || 'text/plain;charset=utf-8' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = String(exported.filename || `audit.${format}`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            URL.revokeObjectURL(url);
            if (exported.truncated) {
                await this.service.modal.success(`최대 ${exported.row_count}건까지 안전 필드로 내보냈습니다.`);
            }
        } catch (error) {
            await this.service.modal.error('감사 로그를 내보내지 못했습니다.');
        } finally {
            this.exporting = false;
            await this.service.render();
        }
    }

    public statusLabel(status: string) {
        const labels: any = {
            success: '성공', pending: '대기', warning: '주의', error: '오류', failed: '실패'
        };
        return labels[status] || status || '-';
    }

    public statusClass(status: string) {
        const classes: any = {
            success: 'bg-emerald-50 text-emerald-700 border-emerald-200',
            pending: 'bg-blue-50 text-blue-700 border-blue-200',
            warning: 'bg-amber-50 text-amber-700 border-amber-200',
            error: 'bg-red-50 text-red-700 border-red-200',
            failed: 'bg-red-50 text-red-700 border-red-200'
        };
        return classes[status] || 'bg-gray-50 text-gray-600 border-gray-200';
    }

    public date(value: any) {
        return String(value || '').replace('T', ' ').slice(0, 19) || '-';
    }
}

export default PageAuditComponent;